import { DeviceInformationHelper, DeviceType } from "./helpers/device-information-helper";
import { BigDataEventConstants } from "./constants/big-data-constants";
import { EventType } from "./constants/event-type-constants";
import { MarketingClientConstants } from "./constants/marketing-client-constants";
import { DOMHelper } from "./helpers/dom-helper";
import { httpInstance } from "./http/http";
import { BigData } from "./marketing-client-bigdata";
import { Spinner } from "./utils/spinner";
import { Utils } from "./utils/utils";
import { LayerType, ShareArticleErrorHandler, WYBORCZA_PL } from "./helpers/swf-helper";
import { DataLayer } from "./datalayer";
import { MetaConversionApi } from "./meta-conversion";
import { MetaConversionConstants } from "./constants/meta-conversion";
import { FamilySharingHelper } from "./helpers/family-sharing-helper";
import { SubShareOnboardingErrorMessage } from "./constants/onboarding-constants";
export class MarketingClientShareSubscriptionBase {
    constructor(utilizationObject) {
        this.utilizationObject = utilizationObject;
        this.layers = {};
        this.mkdmContainerClass = ".mkdm-container";
        this.loggedHideClass = ".logged-hide";
        this.shareArticleFormId = "shareSubscriptionForm";
        this.emailClass = ".share-article-email";
        this.spinnerClass = ".share-article-spinner";
        this.messages = {
            required: "Pole e-mail jest wymagane",
            errorShareMyself: SubShareOnboardingErrorMessage.errorShareMyself,
            errorShareAgain: SubShareOnboardingErrorMessage.errorShareAgain
        };
        this.manualUtilizeAttr = "data-utilize-manual";
        this.orderId = null;
        this.isHarmonyTest = Utils.getURLParamsAsObject().enableHarmonyTest;
        this.path = this.isHarmonyTest
            ? "https://coreos07.wyborcza.pl:8094/squid-home/restricted/customers/familyV2"
            : "https://squid-api.wyborcza.pl/squid-home/restricted/customers/familyV2";
        this.hasInvitations = false;
        this.registeredEmails = [];
        this.invitedEmails = [];
        this.shareSubscriptionURL = this.isHarmonyTest
            ? "https://coreos07.wyborcza.pl:8094/squid-home/restricted/customers/family/add-member"
            : "https://squid-api.wyborcza.pl/squid-home/restricted/customers/family/add-member";
        this.isMobile = DeviceInformationHelper.getDeviceType() === DeviceType.MOBILE;
    }
    initialize() {
        this.form = DOMHelper.getElementById(this.shareArticleFormId);
        if (!this.form) {
            return;
        }
        this.email = this.form ? DOMHelper.querySelector(this.emailClass, this.form) : null;
        this.spinner = new Spinner(this.spinnerClass);
        this.errorHandler = new ShareArticleErrorHandler(this.email);
        this.getFamilyData();
        this.initializeLayers();
        this.hideContainersForLoggedInUser();
    }
    initializeLayers() {
        this.layers[LayerType.DEFAULT] = DOMHelper.getElementById("shareArticleDefaultLayer");
        this.layers[LayerType.ERROR] = DOMHelper.getElementById("shareArticleErrorLayer");
        this.layers[LayerType.SUCCESS] = DOMHelper.getElementById("shareArticleSuccessLayer");
        this.layers[LayerType.BLOCKED] = DOMHelper.getElementById("shareArticleBlockedLayer");
    }
    hideContainersForLoggedInUser() {
        var _a;
        if ((_a = WYBORCZA_PL === null || WYBORCZA_PL === void 0 ? void 0 : WYBORCZA_PL.userInfo) === null || _a === void 0 ? void 0 : _a.loggedIn) {
            const mkdmContainer = DOMHelper.querySelector(this.mkdmContainerClass), mkdmContainerLoggedHide = mkdmContainer && DOMHelper.querySelector(this.loggedHideClass, mkdmContainer);
            if (mkdmContainer && mkdmContainerLoggedHide) {
                mkdmContainerLoggedHide.classList.add(MarketingClientConstants.hiddenClassName);
            }
        }
    }
    getFamilyData() {
        return httpInstance
            .get({
            url: this.path,
            withCredentials: true
        })
            .then(this.successResponseFamilyData.bind(this));
    }
    successResponseFamilyData(response) {
        var _a, _b;
        const data = response.data;
        const mkdmContainer = DOMHelper.querySelector(this.mkdmContainerClass);
        const numberOfRegistered = (_a = data === null || data === void 0 ? void 0 : data.registered) === null || _a === void 0 ? void 0 : _a.length;
        const numberOfInvited = (_b = data === null || data === void 0 ? void 0 : data.invited) === null || _b === void 0 ? void 0 : _b.length;
        this.orderId = data === null || data === void 0 ? void 0 : data.orderId;
        this.registeredEmails = FamilySharingHelper.mapEmails(data === null || data === void 0 ? void 0 : data.registered);
        this.invitedEmails = FamilySharingHelper.mapEmails(data === null || data === void 0 ? void 0 : data.invited);
        this.hasInvitations = numberOfRegistered + numberOfInvited !== 2;
        if (this.hasInvitations) {
            mkdmContainer === null || mkdmContainer === void 0 ? void 0 : mkdmContainer.classList.remove(MarketingClientConstants.hiddenClassName);
        }
        ;
    }
    bindEventsToFormSubmit() {
        if (this.form) {
            this.form.addEventListener(EventType.SUBMIT, (e) => {
                e.preventDefault();
                if (this.validateEmail()) {
                    this.utilizeShareArticle();
                    this.sendData();
                }
            });
        }
    }
    bindEventsToEmailInput() {
        if (this.email) {
            this.email.addEventListener(EventType.CHANGE, this.validateEmail.bind(this));
            this.email.addEventListener(EventType.INPUT, () => {
                var _a;
                return ((_a = this.email) === null || _a === void 0 ? void 0 : _a.value.length) ? this.errorHandler.hide() : this.errorHandler.show(this.messages.required);
            });
        }
    }
    validateEmail() {
        var _a;
        const value = DOMHelper.getEmailValue(this.email), emailIsValid = Utils.validateEmail(value);
        if (!value.length) {
            return this.errorHandler.show(this.messages.required);
        }
        else if (FamilySharingHelper.isSelfEmail(value, (_a = WYBORCZA_PL === null || WYBORCZA_PL === void 0 ? void 0 : WYBORCZA_PL.userInfo) === null || _a === void 0 ? void 0 : _a.email)) {
            return this.errorHandler.show(this.messages.errorShareMyself);
        }
        else if (FamilySharingHelper.isAlreadyInvited(value, this.invitedEmails, this.registeredEmails)) {
            return this.errorHandler.show(this.messages.errorShareAgain);
        }
        else if (!emailIsValid) {
            return this.errorHandler.show();
        }
        else {
            return this.errorHandler.hide();
        }
    }
    utilizeShareArticle() {
        const link = DOMHelper.querySelector(`[${this.manualUtilizeAttr}]`, this.form), parent = link === null || link === void 0 ? void 0 : link.closest(`[${MarketingClientConstants.placeholderDataSetAttribute}]`), condition = link === null || link === void 0 ? void 0 : link.getAttribute(this.manualUtilizeAttr);
        if (link && parent && condition) {
            const dataToSend = this.utilizationObject.prepareDataToSend(parent, condition), ctaObject = Utils.prepareCtaObject(parent), attribute = BigData.prepareDataOceanAttribute(ctaObject, dataToSend);
            BigData.sendDataOceanEvent(BigDataEventConstants.onClick, attribute);
            DataLayer.pushEventToDataLayer(attribute, true);
            MetaConversionApi.sendFBQEvent(attribute, MetaConversionConstants.marketingClick);
            this.utilizationObject.utilize(dataToSend);
        }
    }
    sendData() {
        let data = {
            email: DOMHelper.getEmailValue(this.email),
            orderId: this.orderId
        };
        this.spinner.show();
        return httpInstance
            .put({
            url: this.shareSubscriptionURL,
            data,
            withCredentials: true
        })
            .then(this.successResponseHandler.bind(this), this.errorResponseHandler.bind(this))
            .then(() => {
            this.spinner.hide();
        });
    }
}
